import {
    ATTENDANCE_TEXT,
    GRADE_SCHEMA,
    GRADED_TEXT, POLL_TEXT,
    POLL_TYPE,
    QUESTION_HEADER,
    UNGRADED_TEXT
} from "../../utils/constants";
import classes from "./ReleaseActivityPage.module.css";
import React, {useState, useId} from "react";
import {ReactComponent as INFO_ICON} from "../../images/gray_info_icon.svg";
import {ReactComponent as GRADE_ICON} from "../../images/links/active_gradebook_icon.svg";
import {ReactComponent as QUESTION_MARKER_ICON} from "../../images/question_marker_polygon_purple.svg";
import {ReactComponent as POINTS_ICON} from "../../images/weightage_purple.svg";
import {ReactComponent as POLL_ICON} from "./images/poll_purple_icon.svg";
import {ReactComponent as ATTENDANCE_ICON} from "./images/attendance_purple_icon.svg";
import {ReactComponent as GEOFENCE_ENABLED_ICON} from "./images/geofence_enbaled_purple_icon.svg";
import {ReactComponent as GEOFENCE_DISABLED_ICON} from "./images/geofence_disabled_purple_icon.svg";
import {getQuestionWeightage} from "../../utils/helpers";
import { Popover } from '@base-ui/react/popover';


export default function ViewActivityInfoIcon({pollData}) {


    const {poll = {}, questions = []} = pollData;

    const {gradeSchema, pollType, geofence} = poll;

    const [infoCardOpen, setInfoCardOpen] = useState(false);
    const randomId = useId();



    return (
        <Popover.Root open={!!infoCardOpen} onOpenChange={(open) => setInfoCardOpen(open)}>
            <Popover.Trigger
                delay={0}
                aria-label={"More Info"}
                aria-haspopup="true"
                id={randomId}
                className={`${classes.icon} ${infoCardOpen ? classes.active : ""}`}
            >
                <INFO_ICON/>
            </Popover.Trigger>
            <Popover.Portal >
                <Popover.Positioner sideOffset={5} align={"start"}>
                    <Popover.Popup
                        className={classes.activityInfoCard}
                        role={"region"}
                        aria-modal="false"
                        aria-labelledby={randomId}
                        initialFocus={false}
                    >
                        <Popover.Description
                            render={(props) => <div {...props}></div>}
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                gap: 20
                            }}
                        >
                            <div className={classes.row}>
                                <span className={classes.iconWrapper} style={{marginRight: 7}}>
                                    {pollType === POLL_TYPE.ATTENDANCE
                                        ? <ATTENDANCE_ICON style={{width: 20, height: 20}}/>
                                        : <POLL_ICON style={{width: 20, height: 20}}/>
                                    }

                                </span>
                                {pollType === POLL_TYPE.ATTENDANCE ? ATTENDANCE_TEXT : POLL_TEXT}
                            </div>

                            {pollType === POLL_TYPE.MERGED_POLL &&
                                <div className={classes.row}>
                                    <span className={classes.iconWrapper} style={{marginRight: 7}}>
                                        <GRADE_ICON style={{width: 20, height: 20}}/>
                                    </span>
                                    {gradeSchema === GRADE_SCHEMA.GRADED.key ? GRADED_TEXT : UNGRADED_TEXT}
                                </div>
                            }

                            {pollType === POLL_TYPE.MERGED_POLL &&
                                <div className={classes.row}>
                                    <span className={classes.iconWrapper} style={{marginRight: 7}}>
                                        <QUESTION_MARKER_ICON style={{width: 20, height: 20}}/>
                                    </span>
                                    {questions.length} {QUESTION_HEADER}
                                </div>
                            }

                            {gradeSchema === GRADE_SCHEMA.GRADED.key && pollType !== POLL_TYPE.ATTENDANCE &&
                                <div className={classes.row}>
                                    <span className={classes.iconWrapper} style={{marginRight: 7}}>
                                        <POINTS_ICON/>
                                    </span>
                                    {questions
                                        .map(q => getQuestionWeightage(q))
                                        .reduce((accumulator, currentValue) => {
                                            return accumulator + currentValue
                                        }, 0)
                                    } {"Total Points"}
                                </div>
                            }

                            {pollType === POLL_TYPE.ATTENDANCE &&
                                <div className={classes.row}>
                                    <span className={classes.iconWrapper} style={{marginRight: 7}}>
                                        {!!geofence && !!Object.entries(geofence).length
                                            ? <GEOFENCE_ENABLED_ICON style={{width: 20, height: 20}}/>
                                            : <GEOFENCE_DISABLED_ICON style={{width: 20, height: 20}}/>
                                        }
                                    </span>
                                    {!!geofence && !!Object.entries(geofence).length ? "Geofence Enabled" : "Geofence Disabled"}
                                </div>
                            }
                        </Popover.Description>
                    </Popover.Popup>
                </Popover.Positioner>
            </Popover.Portal>
        </Popover.Root>
    );
}